export const StickerStyle = `
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&family=Roboto:wght@400;700&display=swap');

:root {
    --page-width: 5.7cm;
    --page-height: 9cm;
    --orientation: landscape;
    --margin: 0;
}

@page {
    margin: 0;
}

html, body {
    margin: 0;
}

.rtl {
    direction: rtl;
}

.sticker {
    border: 1px black dashed;
    float: right;
    padding: 0 0.05cm 0 0.05cm;
    width: var(--page-width) !important;
    max-height: var(--page-height) !important;
}

.separateLabels {
    margin: var(--margin) auto;
    page-break-after: always;
    float: none;
    padding: 0;
    line-height: 1.5;
}

.singleBatch {
    width: 100%;
    border-collapse: collapse;
    color: #000;
    table-layout: fixed;
    height: 100%;
}

.singleBatch tbody tr {
    vertical-align: top;
    font-size: 0.38cm !important;
    border-bottom: 1px black dotted;
}

.singleBatch tbody tr td {
    padding: 0.08cm 0.2cm 0.08cm 0.2cm;
}

.singleBatch tbody tr.small-font {
    font-size: 0.3cm !important;
}
.singleBatch tbody tr.medium-font {
    font-size: 0.35cm !important;
}

.singleBatch tbody tr td:nth-child(1) {
    width: 1.7cm;
}

.singleBatch tbody tr td:nth-child(2) {
    font-weight: bold;
    word-wrap: break-word;
}

.wrap {
    word-wrap: break-word;
}

/* single-line truncation with ellipsis */
.truncate {
    display: block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Ensure uniform height for specific rows (e.g., Color) */
.rowFixed {
    height: 0.8cm; /* fits one line at current font-size */
    overflow: hidden;
}

.style_name {
    font-weight: bold;
    padding-top: 0;
    direction: ltr;
    text-align: left;
    word-break: break-all;
}

.cell {
    display: flex;
    justify-content: space-between;
}

.icon {
    width: 0.8cm;
}

.spacing {
    page-break-after: always;
}

/* Force next floated sticker to start on a new row */
.rowBreak {
    clear: both;
    height: 0;
}

.noBorderBottom {
    border-bottom: 0 !important;
}

.noPaddingLeft {
    padding-left: 0 !important;
}

.noPaddingRight {
    padding-right: 0 !important;
}

.alignLeft {
    text-align: left;
}

.alignRight {
    text-align: right;
}

.justifyContent {
    display: flex;
    justify-content: space-between;
}

.marginLeft {
    margin-left: 20px;
}

.marginRight {
    margin-right: 20px;
}

.noMargin {
    margin: 0;
}

.highlight {
    background: #99f3fd;
}

.arabicFont {
    font-family: 'Cairo', sans-serif !important;
}

.englishFont {
    font-family: 'Roboto', sans-serif !important;
}

@font-face {
    font-family: 'Cairo';
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Cairo';
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    font-weight: bold;
    font-style: normal;
}
.d-flex {
   display: flex !important;
}
.w-50 {
   width: 50% !important;
}
.font-weight-bold {
   font-weight: bold !important;
}
.pb-0 {
   padding-bottom: 0!important;
}
.pt-0 {
   padding-top: 0!important;
}

/* Fill remaining height in the last row and center content vertically */
.fillRow {
   height: 100% !important;
  vertical-align: middle !important;

}
.tdFillHeight {
   height: 100% !important;
}
.vCenterContent {
   display: flex;
   align-items: center;
   justify-content: flex-end;
   height: 100%;
}
 `;
